var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.189,
    height: 60.414,
    viewBox: "0 0 42.189 60.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Polygon_8",
    "data-name": "Polygon 8",
    transform: "translate(42.189 1.401) rotate(92)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.524,0,59.048,40.153H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29.52410697937012 5.064220428466797 L 5.929573059082031 37.15278244018555 L 53.1186408996582 37.15278244018555 L 29.52410697937012 5.064220428466797 M 29.52410697937012 -3.814697265625e-06 L 59.0482177734375 40.15278244018555 L -3.814697265625e-06 40.15278244018555 L 29.52410697937012 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#37343a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayImage);
export default __webpack_public_path__ + "static/media/playImage.a13788333c85341134a52f50616c3089.svg";
export { ForwardRef as ReactComponent };